// Lightweight i18n dictionaries. Product data (names, dimensions, prices) is never translated here.
export const LANGS = [
  { code: "id", label: "Indonesia", dir: "ltr" },
  { code: "en", label: "English", dir: "ltr" },
  { code: "ar", label: "العربية", dir: "rtl" },
];

const dict = {
  id: {
    nav: { 
      beranda: "Beranda", 
      produk: "Produk", 
      cara_pesan: "Cara Pesan", 
      kontak: "Kontak",
      lacak: "Lacak Pesanan",
      masuk_akun: "Masuk Akun",
      akun_saya: "Akun Saya",
      pasang_hp: "Pasang Aplikasi di Layar HP",
      pilih_bahasa: "Pilih bahasa", 
    },
    btn: { pesan_sekarang: "Pesan Sekarang", lihat_produk: "Lihat Produk", pilih_produk: "Pilih Produk",
      add_to_cart: "Tambah ke Keranjang", order_now: "Pesan Sekarang", checkout: "Checkout", lanjut: "Lanjut",
      kembali: "Kembali", submit: "Pesan Sekarang", beranda: "Beranda", salin: "Salin Ringkasan" },
    home: { 
      welcome: "Selamat datang di Sogil Furniture 👋",
      badge: "Furniture Praktis Buatan Sogil",
      choose_title: "Pilih kebutuhanmu",
      choose_subtitle: "Lihat koleksi furniture Sogil.",
      help_title: "Butuh bantuan memilih?",
      help_subtitle: "Ikuti langkah sederhana untuk memilih furniture sampai melakukan pemesanan.",
      help_prompt: "Tekan tombol ? di pojok bawah.",
      empty_title: "Produk belum tersedia",
      empty_subtitle: "Silakan coba lagi beberapa saat lagi.",
      title: "Furniture Praktis, Harga Transparan, Pesan Lebih Mudah.",
      subtitle: "Temukan furniture yang sesuai kebutuhanmu, pilih ukuran dan finishing, lalu lihat estimasi harga secara langsung.",
      featured: "Produk Pilihan", featured_sub: "Bisa dikonfigurasi sesuai kebutuhanmu.", lihat_semua: "Lihat semua",
      f1t: "Ukuran Fleksibel", f1d: "Pilih ukuran, tingkat, dan finishing sesuai ruang kamu.",
      f2t: "Harga Transparan", f2d: "Lihat estimasi harga langsung sebelum memesan.",
      f3t: "Pesan via WhatsApp", f3d: "Checkout cepat, admin tinggal konfirmasi." },
    help: {
      aria_label: "Bantuan cara pesan",
      title: "Cara Pesan",
      description: "Pesan furniture Sogil dengan mudah dalam beberapa langkah.",
      step1_title: "Pilih kategori",
      step1_description: "Pilih jenis furniture yang kamu butuhkan.",
      step2_title: "Pilih produk",
      step2_description: "Lihat foto dan detail produk yang tersedia.",
      step3_title: "Sesuaikan ukuran & finishing",
      step3_description: "Pilih spesifikasi yang sesuai dengan kebutuhanmu.",
      step4_title: "Cek harga",
      step4_description: "Harga akan dihitung berdasarkan pilihanmu.",
      step5_title: "Pesan via WhatsApp",
      step5_description: "Lanjutkan pesanan dan konfirmasi melalui WhatsApp.",
      done: "Mengerti",
    },
    cat: {
      rak: "Rak",
      meja: "Meja",
      meja_rak: "Meja Rak",
      papan_tulis: "Papan Tulis",
      blockboard: "BlackBoard",
      custom: "Koleksi Custom",

      rak_desc: "Rapikan kitab, buku, dan barang dengan lebih teratur.",
      meja_desc: "Meja belajar yang nyaman untuk ruang dan kebutuhanmu.",
      meja_rak_desc: "Praktis untuk belajar sekaligus menyimpan barang.",
      papan_tulis_desc: "Cocok untuk belajar, mengajar, dan berbagai kebutuhan.",
      blockboard_desc: "Pilihan papan tulis untuk kebutuhan belajar dan aktivitasmu.",
      custom_desc: "Kumpulan karya dan desain custom pilihan dari Sogil Furniture.",

      default_desc: "Temukan produk Sogil Furniture yang sesuai dengan kebutuhanmu.",
      collection: "Koleksi Sogil Furniture",
      empty_title: "Produk belum tersedia",
      empty_desc: "Belum ada produk yang tersedia di kategori ini.",
      back_catalog: "Kembali ke katalog",
      pilihan: "Pilihan Produk", pilihan_sub: "Pilih furniture, atur kebutuhanmu, dan langsung lihat estimasi harganya.",
      mulai: "Mulai", segera: "Segera tersedia", konfirmasi_wa: "Konfirmasi via WhatsApp", memuat: "Memuat produk..." },
    cfg: { 
      jenis_pesanan: "Jenis Pesanan", ukuran_standar: "Ukuran Standar", ukuran_custom: "Ukuran Custom / Request Khusus",
      pilih_ukuran: "Pilih Ukuran (Panjang)", jumlah_tingkat: "Jumlah Tingkat", tipe_rak: "Tipe Rak",
      tipe: "Tipe", jenis_finishing: "Jenis Finishing", jumlah: "Jumlah", ukuran_tabletop: "Ukuran Meja",
      tinggi_meja: "Tinggi Meja", tinggi: "Tinggi", pilih_varian: "Pilih Varian", tingkat: "Tingkat",
      tipe_hint: "B: atas terbuka · A: atas tertutup",
      custom_info: "Ukuran custom dapat dikonsultasikan dengan admin terlebih dahulu. Silakan jelaskan kebutuhan Anda.",
      custom_ph: "Contoh: Lebar 70 cm, tinggi sekitar 180 cm, kalau memungkinkan.",
      custom_note: "Pesanan ini akan ditandai untuk konfirmasi admin. Estimasi harga menyusul setelah dikonfirmasi.",
      segera_t: "Segera tersedia", segera_d: "Detail pemesanan produk ini akan dikonfirmasi melalui WhatsApp. Silakan lanjutkan dan isi data serta catatan kebutuhanmu.",
      ref_photo: "Foto referensi (konfigurasi terdekat)", exact_photo: "Foto sesuai konfigurasi", kembali_produk: "Kembali ke Beranda",
      spesifikasi_desain: "Spesifikasi Desain",
      lesehan: "Lesehan",
      kursi: "Kursi",
    },
    sum: { ringkasan: "Ringkasan Pesanan", harga_dasar: "Harga dasar", subtotal: "Subtotal", pengiriman: "Pengiriman",
      estimasi_total: "Estimasi Total", rate_label: "Estimasi berdasarkan rate", akan_dikonfirmasi: "Estimasi harga akan dikonfirmasi oleh admin untuk pesanan ini.",
      disclaimer: "Harga dalam Rupiah merupakan estimasi dan dapat berubah mengikuti rate saat konfirmasi pembayaran.",
      discount_line: "Diskon", discount_ph: "Kode diskon", discount_apply: "Pakai", discount_ok: "Diskon diterapkan", discount_bad: "Kode diskon tidak valid",
      promo_require_auth: "Untuk menggunakan kode promo atau referral, silakan buat akun atau masuk terlebih dahulu." },
    cart: { title: "Keranjang", empty: "Keranjang masih kosong.", belanja: "Mulai Belanja", item: "Item", hapus: "Hapus",
      total_produk: "Total Produk", metode: "Metode Penerimaan", grand_total: "Estimasi Total", lanjut_checkout: "Lanjut ke Checkout",
      tambah_lagi: "Tambah Produk Lain" },
    del: { ambil: "Ambil di Toko", ambil_d: "Gratis · Ambil langsung di toko", kirim: "Pengiriman", kirim_d: "Diantar ke alamatmu",
      pilih_zona: "Pilih Zona Pengiriman", alamat_toko: "Alamat Toko" },
    chk: { title: "Data Pemesan", nama: "Nama", no_hp: "No WhatsApp", alamat: "Alamat",
      alamat_ph: "No. Imarah, jalan, area/distrik, lantai, no. syaqqoh",
      alamat_help: "Sebutkan no. imarah, jalan, distrik/area, lantai, & no. syaqqoh untuk memudahkan kurir.",
      link_maps: "Link Maps",
      foto_gedung: "Foto Gedung / Imarah",
      foto_gedung_help: "Unggah foto bagian depan gedung atau pintu masuk untuk memudahkan kurir menemukan lokasi Anda.",
      foto_gedung_opsional: "(Opsional)",
      unggah_foto: "Unggah Foto",
      hapus_foto: "Hapus Foto",
      maps_saran: "(disarankan)", maps_opsional: "(opsional)", metode_bayar: "Metode Pembayaran",
      cash: "Cash", transfer: "Transfer", transfer_note: "Konfirmasi pembayaran transfer akan diproses melalui WhatsApp setelah pesanan dibuat.",
      catatan: "Catatan / Request Tambahan (opsional)", catatan_ph: "Catatan tambahan untuk admin", review: "Review Pesanan",
      phone_ph: "+62xxxxxxxxxx",
      phone_help: "Gunakan format internasional dengan kode negara, misalnya +20, +62, atau +60.",
      disclaimer: "Total di atas merupakan estimasi. Harga dapat disesuaikan setelah konfirmasi admin, terutama untuk request khusus/custom." },
    conf: { tersimpan: "Pesanan Tersimpan!", nomor: "Nomor pesananmu:", produk: "Produk", estimasi_total: "Estimasi Total",
      perlu_konfirmasi: "Pesanan ini memerlukan konfirmasi admin (custom/khusus).",
      wa_info: "Kami akan membuka WhatsApp otomatis. Jika tidak terbuka, tekan tombol di bawah.", lanjut_wa: "Lanjutkan ke WhatsApp" },
    err: { 
      nama: "Nama tidak boleh kosong.", phone: "No HP harus diawali + dan kode negara. Contoh: +62xxxxxxxxxx",
      alamat: "Alamat tidak boleh kosong.", metode: "Silakan pilih metode penerimaan barang.", zona: "Silakan pilih zona pengiriman.",
      bayar: "Silakan pilih metode pembayaran.", maps: "Link Maps tidak valid.", cfg: "Lengkapi konfigurasi produk terlebih dahulu.",
      custom_note: "Silakan jelaskan kebutuhan custom Anda.", gagal: "Terjadi kesalahan saat menyimpan pesanan. Silakan coba lagi.",
      cart_added: "Ditambahkan ke keranjang", cart_empty: "Keranjang masih kosong.", product_not_found: "Produk tidak ditemukan",
     },
    auth: {
      title_login: "Masuk Akun",
      title_register: "Daftar Akun",
      subtitle: "Login untuk poin & referral. Belanja tetap bisa tanpa akun.",
      username: "Username",
      phone: "No HP (+kode negara)",
      phone_ph: "+62xxxxxxxxxx",
      phone_help: "Gunakan format internasional dengan kode negara, misalnya +20, +62, atau +60.",
      identifier: "Username / No HP",
      password: "Kata Sandi",
      btn_login: "Masuk",
      btn_register: "Daftar",
      have_acc: "Sudah punya akun? Masuk",
      no_acc: "Belum punya akun? Daftar",
      forgot_toggle: "Lupa username / kata sandi?",
      recover_prompt: "Masukkan No HP terdaftar untuk menemukan username kamu.",
      btn_search: "Cari",
      your_username: "Username kamu:",
      forgot_note: "Lupa kata sandi? Hubungi admin/toko via WhatsApp untuk reset yang aman — admin tidak pernah bisa melihat sandi lama, hanya menyetel sandi baru.",
      hello: "Halo",
      logout: "Keluar",
      points_available: "Poin Tersedia",
      points_rate: "1 poin = 1 LE",
      points_earned: "Total Diperoleh",
      points_redeemed: "Total Ditukar",
      ref_title: "Kode Referral Kamu",
      ref_copied: "Kode disalin",
      ref_desc: "Bagikan kode ini — kamu dapat poin saat pesanan referral dibayar.",
      claim_title: "Klaim Pesanan Sebelumnya",
      claim_desc: "Pernah pesan sebagai tamu? Klaim pesanan ke akun ini dengan nomor pesanan & No HP yang dipakai saat memesan.",
      claim_order_num_ph: "SGF-20260827-001",
      claim_phone_ph: "+62xxxxxxxxxx",
      claim_btn: "Klaim Pesanan",
      claim_success: "Pesanan berhasil diklaim",
      claim_err_fill: "Isi nomor pesanan & No HP",
      change_pw_title: "Ubah Kata Sandi",
      pw_current_ph: "Sandi saat ini",
      pw_new_ph: "Sandi baru (min 6)",
      pw_confirm_ph: "Konfirmasi sandi baru",
      pw_btn: "Simpan Sandi Baru",
      pw_success: "Kata sandi diperbarui",
      pw_err_incomplete: "Lengkapi sandi",
      pw_err_mismatch: "Konfirmasi sandi tidak cocok",
      order_history: "Riwayat Pesanan",
      no_orders: "Belum ada pesanan.",
      points_history: "Riwayat Poin",
      loading: "Memuat...",
      login_success: "Berhasil masuk",
    },
    track: {
      title: "Lacak Pesanan",
      desc: "Masukkan nomor pesanan & No HP yang dipakai saat memesan. Tidak perlu akun.",
      order_num: "Nomor Pesanan",
      phone: "No HP (+kode negara)",
      phone_ph: "+62xxxxxxxxxx",
      phone_help: "Gunakan format internasional dengan kode negara, misalnya +20, +62, atau +60.",
      btn_track: "Lacak",
      searching: "Mencari...",
      err_fill: "Isi nomor pesanan & No HP",
      for_customer: "Atas nama",
    },
  },
  en: {
    nav: { 
      beranda: "Home", 
      produk: "Products", 
      cara_pesan: "How to Order", 
      kontak: "Contact",
      lacak: "Track Order",
      masuk_akun: "Sign In",
      akun_saya: "My Account",
      pasang_hp: "Install App on Home Screen",
      pilih_bahasa: "Choose language",
    },
    btn: { pesan_sekarang: "Order Now", lihat_produk: "View Products", pilih_produk: "Select Product",
      add_to_cart: "Add to Cart", order_now: "Order Now", checkout: "Checkout", lanjut: "Continue",
      kembali: "Back", submit: "Place Order", beranda: "Home", salin: "Copy Summary" },
    home: { 
      welcome: "Welcome to Sogil Furniture 👋",
      badge: "Practical Furniture by Sogil",
      choose_title: "Choose what you need",
      choose_subtitle: "Explore Sogil's furniture collection.",
      help_title: "Need help choosing?",
      help_subtitle: "Follow a few simple steps to choose your furniture and place your order.",
      help_prompt: "Tap the ? button in the bottom corner.",
      empty_title: "No products available",
      empty_subtitle: "Please try again in a little while.",
      title: "Practical Furniture, Transparent Prices, Easier Ordering.",
      subtitle: "Find furniture that fits your needs, choose the size and finishing, then see the price estimate instantly.",
      featured: "Featured Products", featured_sub: "Configurable to your needs.", lihat_semua: "View all",
      f1t: "Flexible Sizing", f1d: "Choose size, levels, and finishing for your space.",
      f2t: "Transparent Pricing", f2d: "See the price estimate before you order.",
      f3t: "Order via WhatsApp", f3d: "Fast checkout, admin just confirms." },
    help: {
      aria_label: "Help with ordering",
      title: "How to Order",
      description: "Order Sogil furniture easily in just a few steps.",
      step1_title: "Choose a category",
      step1_description: "Choose the type of furniture you need.",
      step2_title: "Choose a product",
      step2_description: "View available product photos and details.",
      step3_title: "Customize size & finishing",
      step3_description: "Choose the specifications that fit your needs.",
      step4_title: "Check the price",
      step4_description: "The price will be calculated based on your selections.",
      step5_title: "Order via WhatsApp",
      step5_description: "Continue your order and confirm it via WhatsApp.",
      done: "Got it",
    },
    cat: { 
      rak: "Rack",
      meja: "Table",
      meja_rak: "Table Rack",
      papan_tulis: "Whiteboard",
      blockboard: "BlackBoard",
      custom: "Custom Collection",

      rak_desc: "Keep your books, study materials, and belongings neatly organized.",
      meja_desc: "A comfortable study table for your space and needs.",
      meja_rak_desc: "Practical for studying while keeping your belongings organized.",
      papan_tulis_desc: "Suitable for studying, teaching, and various activities.",
      blockboard_desc: "A whiteboard option for study and activity needs.",
      custom_desc: "A curated collection of bespoke furniture crafted by Sogil.",

      default_desc: "Find Sogil Furniture products that fit your needs.",
      collection: "Sogil Furniture Collection",
      empty_title: "No products available",
      empty_desc: "There are no products available in this category yet.",
      back_catalog: "Back to catalog",
      pilihan: "Our Products", pilihan_sub: "Pick furniture, configure it, and see the price estimate instantly.",
      mulai: "From", segera: "Coming soon", konfirmasi_wa: "Confirm via WhatsApp", memuat: "Loading products..." },
    cfg: { 
      jenis_pesanan: "Order Type", ukuran_standar: "Standard Size", ukuran_custom: "Custom Size / Special Request",
      pilih_ukuran: "Choose Size (Length)", jumlah_tingkat: "Number of Levels", tipe_rak: "Rack Type",
      tipe: "Type", jenis_finishing: "Finishing", jumlah: "Quantity", ukuran_tabletop: "Table Size",
      tinggi_meja: "Table Height", tinggi: "Height", pilih_varian: "Choose Variant", tingkat: "Levels",
      tipe_hint: "B: open top · A: closed top",
      custom_info: "Custom sizes can be discussed with our admin first. Please describe your needs.",
      custom_ph: "e.g. Width 70 cm, height around 180 cm, if possible.",
      custom_note: "This order will be flagged for admin confirmation. Price estimate follows after confirmation.",
      segera_t: "Coming soon", segera_d: "Ordering details for this product will be confirmed via WhatsApp. Please continue and fill in your details and notes.",
      ref_photo: "Reference photo (closest configuration)", exact_photo: "Photo matches configuration", kembali_produk: "Back to Home",
      spesifikasi_desain: "Design Specifications",
      lesehan: "Floor Seating",
      kursi: "Chair",
    },
    sum: { ringkasan: "Order Summary", harga_dasar: "Base price", subtotal: "Subtotal", pengiriman: "Delivery",
      estimasi_total: "Estimated Total", rate_label: "Estimate based on rate", akan_dikonfirmasi: "Price will be confirmed by admin for this order.",
      disclaimer: "The Rupiah price is an estimate and may change according to the rate at payment confirmation.",
      discount_line: "Discount", discount_ph: "Discount code", discount_apply: "Apply", discount_ok: "Discount applied", discount_bad: "Invalid discount code",
      promo_require_auth: "To use a promo or referral code, please log in or create an account first." },
    cart: { title: "Cart", empty: "Your cart is empty.", belanja: "Start Shopping", item: "Item", hapus: "Remove",
      total_produk: "Products Total", metode: "Receiving Method", grand_total: "Estimated Total", lanjut_checkout: "Proceed to Checkout",
      tambah_lagi: "Add More Products" },
    del: { ambil: "Store Pickup", ambil_d: "Free · Pick up at the store", kirim: "Delivery", kirim_d: "Delivered to your address",
      pilih_zona: "Choose Delivery Zone", alamat_toko: "Store Address" },
    chk: { title: "Customer Details", nama: "Name", no_hp: "WhatsApp Number", alamat: "Address",
      alamat_ph: "Building/Imarah no., street, area/district, floor, apt/syaqqoh no.",
      alamat_help: "Specify building no., street, area, floor, & apt number to guide delivery.",
      link_maps: "Maps Link",
      foto_gedung: "Building / Imarah Photo",
      foto_gedung_help: "Upload a front-view photo of the building or entrance to assist the courier.",
      foto_gedung_opsional: "(Optional)",
      unggah_foto: "Upload Photo",
      hapus_foto: "Remove Photo",
      maps_saran: "(recommended)", maps_opsional: "(optional)", metode_bayar: "Payment Method",
      cash: "Cash", transfer: "Transfer", transfer_note: "Transfer payment confirmation will be handled via WhatsApp after the order is created.",
      catatan: "Notes / Extra Request (optional)", catatan_ph: "Additional notes for admin", review: "Review Order",
      phone_ph: "+62xxxxxxxxxx",
      phone_help: "Use international format with country code, e.g. +20, +62, or +60.",
      disclaimer: "The total above is an estimate. Prices may be adjusted after admin confirmation, especially for special/custom requests." },
    conf: { tersimpan: "Order Saved!", nomor: "Your order number:", produk: "Product", estimasi_total: "Estimated Total",
      perlu_konfirmasi: "This order requires admin confirmation (custom/special).",
      wa_info: "We'll open WhatsApp automatically. If it doesn't open, tap the button below.", lanjut_wa: "Continue to WhatsApp" },
    err: { nama: "Name cannot be empty.", phone: "Phone must start with + and country code. e.g. +62xxxxxxxxxx",
      alamat: "Address cannot be empty.", metode: "Please choose a receiving method.", zona: "Please choose a delivery zone.",
      bayar: "Please choose a payment method.", maps: "Invalid Maps link.", cfg: "Please complete the product configuration first.",
      custom_note: "Please describe your custom request.", gagal: "An error occurred while saving the order. Please try again.",
      cart_added: "Added to cart", cart_empty: "Your cart is empty.", product_not_found: "Product not found",
     },
    auth: {
      title_login: "Sign In",
      title_register: "Create Account",
      subtitle: "Login for points & referrals. Shopping is always available without an account.",
      username: "Username",
      phone: "Phone (+country code)",
      phone_ph: "+62xxxxxxxxxx",
      phone_help: "Use international format with country code, e.g. +20, +62, or +60.",
      identifier: "Username / Phone",
      password: "Password",
      btn_login: "Sign In",
      btn_register: "Register",
      have_acc: "Already have an account? Sign In",
      no_acc: "Don't have an account? Register",
      forgot_toggle: "Forgot username / password?",
      recover_prompt: "Enter your registered phone number to find your username.",
      btn_search: "Search",
      your_username: "Your username:",
      forgot_note: "Forgot your password? Contact store admin via WhatsApp for a secure reset — admin can never view old passwords, only set a new temporary one.",
      hello: "Hello",
      logout: "Logout",
      points_available: "Available Points",
      points_rate: "1 point = 1 LE",
      points_earned: "Total Earned",
      points_redeemed: "Total Redeemed",
      ref_title: "Your Referral Code",
      ref_copied: "Code copied",
      ref_desc: "Share this code — earn points when referral orders are paid.",
      claim_title: "Claim Past Orders",
      claim_desc: "Ordered as a guest before? Link past orders to this account using the order number & phone from that order.",
      claim_order_num_ph: "SGF-20260827-001",
      claim_phone_ph: "+62xxxxxxxxxx",
      claim_btn: "Claim Order",
      claim_success: "Order claimed successfully",
      claim_err_fill: "Please fill in order number & phone",
      change_pw_title: "Change Password",
      pw_current_ph: "Current password",
      pw_new_ph: "New password (min 6)",
      pw_confirm_ph: "Confirm new password",
      pw_btn: "Save New Password",
      pw_success: "Password updated",
      pw_err_incomplete: "Please fill in all password fields",
      pw_err_mismatch: "Password confirmation does not match",
      order_history: "Order History",
      no_orders: "No orders yet.",
      points_history: "Points History",
      loading: "Loading...",
      login_success: "Signed in successfully",
    },
    track: {
      title: "Track Order",
      desc: "Enter the order number & phone number used during ordering. No account required.",
      order_num: "Order Number",
      phone: "Phone (+country code)",
      phone_ph: "+62xxxxxxxxxx",
      phone_help: "Use international format with country code, e.g. +20, +62, or +60.",
      btn_track: "Track",
      searching: "Searching...",
      err_fill: "Please fill in order number & phone",
      for_customer: "For",
    },
  },
  ar: {
    nav: { 
      beranda: "الرئيسية", 
      produk: "المنتجات", 
      cara_pesan: "طريقة الطلب", 
      kontak: "اتصل بنا",
      lacak: "تتبع الطلب",
      masuk_akun: "تسجيل الدخول",
      akun_saya: "حسابي",
      pasang_hp: "تثبيت التطبيق على الشاشة",
      pilih_bahasa: "اختر اللغة",
    },
    btn: { pesan_sekarang: "اطلب الآن", lihat_produk: "عرض المنتجات", pilih_produk: "اختر المنتج",
      add_to_cart: "أضف إلى السلة", order_now: "اطلب الآن", checkout: "إتمام الطلب", lanjut: "متابعة",
      kembali: "رجوع", submit: "تأكيد الطلب", beranda: "الرئيسية", salin: "نسخ الملخص" },
    home: {
      welcome: "مرحبًا بك في أثاث سوجيل 👋",
      badge: "أثاث عملي من سوجيل",
      choose_title: "اختر ما تحتاجه",
      choose_subtitle: "استكشف مجموعة أثاث سوجيل.",
      help_title: "تحتاج مساعدة في الاختيار؟",
      help_subtitle: "اتبع بضع خطوات بسيطة لاختيار الأثاث وإتمام طلبك.",
      help_prompt: "اضغط على زر ؟ في الزاوية السفلية.",
      empty_title: "لا توجد منتجات متاحة",
      empty_subtitle: "يرجى المحاولة مرة أخرى بعد قليل.",
      title: "أثاث عملي، أسعار شفافة، طلب أسهل.",
      subtitle: "اعثر على الأثاث المناسب لاحتياجاتك، اختر المقاس والتشطيب، ثم شاهد تقدير السعر فورًا.",
      featured: "منتجات مختارة", featured_sub: "قابلة للتخصيص حسب احتياجك.", lihat_semua: "عرض الكل",
      f1t: "مقاسات مرنة", f1d: "اختر المقاس والطبقات والتشطيب لمساحتك.",
      f2t: "تسعير شفاف", f2d: "شاهد تقدير السعر قبل الطلب.",
      f3t: "اطلب عبر واتساب", f3d: "إتمام سريع، والإدارة تؤكد فقط." },
    help: {
      aria_label: "المساعدة في طريقة الطلب",
      title: "طريقة الطلب",
      description: "اطلب أثاث سوجيل بسهولة في بضع خطوات.",
      step1_title: "اختر الفئة",
      step1_description: "اختر نوع الأثاث الذي تحتاجه.",
      step2_title: "اختر المنتج",
      step2_description: "شاهد صور المنتجات المتاحة وتفاصيلها.",
      step3_title: "خصص المقاس والتشطيب",
      step3_description: "اختر المواصفات التي تناسب احتياجاتك.",
      step4_title: "تحقق من السعر",
      step4_description: "سيتم حساب السعر بناءً على اختياراتك.",
      step5_title: "اطلب عبر واتساب",
      step5_description: "تابع طلبك وقم بتأكيده عبر واتساب.",
      done: "فهمت",
    },
    cat: { 
      rak: "رفوف",
      meja: "طاولة",
      meja_rak: "طاولة مع رف",
      papan_tulis: "لوح أبيض",
      blockboard: "BlackBoard",
      custom: "مجموعة مخصصة",

      rak_desc: "رتّب كتبك وموادك الدراسية وأغراضك بشكل أكثر تنظيمًا.",
      meja_desc: "طاولة دراسة مريحة تناسب مساحتك واحتياجاتك.",
      meja_rak_desc: "عملية للدراسة مع توفير مساحة لترتيب أغراضك.",
      papan_tulis_desc: "مناسبة للدراسة والتدريس والعديد من الاستخدامات.",
      blockboard_desc: "خيار مناسب للوح الأبيض للدراسة والأنشطة المختلفة.",
      custom_desc: "مجموعة مختارة من التصاميم المخصصة السابقة من سوجيل.",

      default_desc: "اكتشف منتجات سوجيل للأثاث التي تناسب احتياجاتك.",
      collection: "مجموعة سوجيل للأثاث",
      empty_title: "لا توجد منتجات متاحة",
      empty_desc: "لا توجد منتجات متاحة في هذه الفئة حاليًا.",
      back_catalog: "العودة إلى الكتالوج",
      pilihan: "منتجاتنا", pilihan_sub: "اختر الأثاث، خصّصه، وشاهد تقدير السعر فورًا.",
      mulai: "يبدأ من", segera: "قريبًا", konfirmasi_wa: "التأكيد عبر واتساب", memuat: "جارٍ تحميل المنتجات..." },
    cfg: { 
      jenis_pesanan: "نوع الطلب", ukuran_standar: "مقاس قياسي", ukuran_custom: "مقاس مخصص / طلب خاص",
      pilih_ukuran: "اختر المقاس (الطول)", jumlah_tingkat: "عدد الطبقات", tipe_rak: "نوع الرف",
      tipe: "النوع", jenis_finishing: "التشطيب", jumlah: "الكمية", ukuran_tabletop: "مقاس الطاولة",
      tinggi_meja: "ارتفاع الطاولة", pilih_varian: "اختر النوع", tingkat: "طبقات",
      tipe_hint: "B: علوي مفتوح · A: علوي مغلق · +: لوح خلفي خشبي",
      custom_info: "يمكن مناقشة المقاسات المخصصة مع الإدارة أولاً. يرجى وصف احتياجاتك.",
      custom_ph: "مثال: عرض 70 سم، ارتفاع حوالي 180 سم، إن أمكن.",
      custom_note: "سيتم وضع علامة على هذا الطلب لتأكيد الإدارة. يتبع تقدير السعر بعد التأكيد.",
      segera_t: "قريبًا", segera_d: "سيتم تأكيد تفاصيل طلب هذا المنتج عبر واتساب. يرجى المتابعة وملء بياناتك وملاحظاتك.",
      ref_photo: "صورة مرجعية (أقرب تكوين)", exact_photo: "الصورة مطابقة للتكوين", kembali_produk: "العودة للرئيسية",
      spesifikasi_desain: "مواصفات التصميم",
      lesehan: "جلوس أرضي",
      kursi: "كرسي",
    },
    sum: { ringkasan: "ملخص الطلب", harga_dasar: "السعر الأساسي", subtotal: "المجموع الفرعي", pengiriman: "التوصيل",
      estimasi_total: "الإجمالي التقديري", rate_label: "التقدير بناءً على السعر", akan_dikonfirmasi: "سيتم تأكيد السعر من قبل الإدارة لهذا الطلب.",
      disclaimer: "السعر بالروبية تقديري وقد يتغير حسب سعر الصرف عند تأكيد الدفع.",
      discount_line: "خصم", discount_ph: "كود الخصم", discount_apply: "تطبيق", discount_ok: "تم تطبيق الخصم", discount_bad: "كود خصم غير صالح",
      promo_require_auth: "لاستخدام كود الخصم أو الإحالة، يرجى تسجيل الدخول أو إنشاء حساب أولاً." },
    cart: { title: "السلة", empty: "سلتك فارغة.", belanja: "ابدأ التسوق", item: "عنصر", hapus: "حذف",
      total_produk: "إجمالي المنتجات", metode: "طريقة الاستلام", grand_total: "الإجمالي التقديري", lanjut_checkout: "المتابعة للدفع",
      tambah_lagi: "أضف منتجات أخرى" },
    del: { ambil: "الاستلام من المتجر", ambil_d: "مجاني · استلم من المتجر", kirim: "التوصيل", kirim_d: "يُوصَّل إلى عنوانك",
      pilih_zona: "اختر منطقة التوصيل", alamat_toko: "عنوان المتجر" },
    chk: { title: "بيانات العميل", nama: "الاسم", no_hp: "رقم الواتساب", alamat: "العنوان",
      alamat_ph: "رقم العمارة، الشارع، المنطقة، الدور، رقم الشقة",
      alamat_help: "يرجى توضيح رقم العمارة، الشارع، المنطقة، الدور، ورقم الشقة لتسهيل وصول المندوب.",
      link_maps: "رابط الخرائط",
      foto_gedung: "صورة العمارة / المبنى",
      foto_gedung_help: "يمكنك رفع صورة واجهة المبنى أو المدخل لمساعدة مندوب التوصيل في الوصول.",
      foto_gedung_opsional: "(اختياري)",
      unggah_foto: "رفع صورة",
      hapus_foto: "حذف الصورة",
      maps_saran: "(موصى به)", maps_opsional: "(اختياري)", metode_bayar: "طريقة الدفع",
      cash: "نقدًا", transfer: "تحويل", transfer_note: "سيتم تأكيد الدفع بالتحويل عبر واتساب بعد إنشاء الطلب.",
      catatan: "ملاحظات / طلب إضافي (اختياري)", catatan_ph: "ملاحظات إضافية للإدارة", review: "مراجعة الطلب",
      phone_ph: "+62xxxxxxxxxx",
      phone_help: "استخدم التنسيق الدولي مع رمز الدولة، على سبيل المثال +20 أو +62 أو +60.",
      disclaimer: "الإجمالي أعلاه تقديري. قد يتم تعديل الأسعار بعد تأكيد الإدارة، خاصة للطلبات الخاصة/المخصصة." },
    conf: { tersimpan: "تم حفظ الطلب!", nomor: "رقم طلبك:", produk: "المنتج", estimasi_total: "الإجمالي التقديري",
      perlu_konfirmasi: "يتطلب هذا الطلب تأكيد الإدارة (مخصص/خاص).",
      wa_info: "سنفتح واتساب تلقائيًا. إذا لم يفتح، اضغط الزر أدناه.", lanjut_wa: "المتابعة إلى واتساب" },
    err: { nama: "الاسم مطلوب.", phone: "يجب أن يبدأ الهاتف بـ + ورمز الدولة. مثال: +62xxxxxxxxxx",
      alamat: "العنوان مطلوب.", metode: "يرجى اختيار طريقة الاستلام.", zona: "يرجى اختيار منطقة التوصيل.",
      bayar: "يرجى اختيار طريقة الدفع.", maps: "رابط الخرائط غير صالح.", cfg: "يرجى إكمال تكوين المنتج أولاً.",
      custom_note: "يرجى وصف طلبك المخصص.", gagal: "حدث خطأ أثناء حفظ الطلب. حاول مرة أخرى.",
      cart_added: "أُضيف إلى السلة", cart_empty: "سلتك فارغة.", product_not_found: "المنتج غير موجود",
     },
    auth: {
      title_login: "تسجيل الدخول",
      title_register: "إنشاء حساب",
      subtitle: "سجّل الدخول لكسب النقاط والإحالات. يمكنك دائمًا التسوق دون حساب.",
      username: "اسم المستخدم",
      phone: "رقم الهاتف (+رمز الدولة)",
      phone_ph: "+62xxxxxxxxxx",
      phone_help: "استخدم التنسيق الدولي مع رمز الدولة، على سبيل المثال +20 أو +62 أو +60.",
      identifier: "اسم المستخدم / رقم الهاتف",
      password: "كلمة المرور",
      btn_login: "دخول",
      btn_register: "تسجيل",
      have_acc: "لديك حساب بالفعل؟ تسجيل الدخول",
      no_acc: "ليس لديك حساب؟ إنشاء حساب",
      forgot_toggle: "نسيت اسم المستخدم / كلمة المرور؟",
      recover_prompt: "أدخل رقم هاتفك المسجل للعثور على اسم المستخدم الخاص بك.",
      btn_search: "بحث",
      your_username: "اسم المستخدم الخاص بك:",
      forgot_note: "نسيت كلمة المرور؟ اتصل بالإدارة عبر واتساب لإعادة التعيين بأمان — لا يمكن للمسؤول رؤية كلمة المرور القديمة، فقط تعيين كلمة مرور جديدة.",
      hello: "مرحبًا",
      logout: "تسجيل الخروج",
      points_available: "النقاط المتاحة",
      points_rate: "1 نقطة = 1 جنيه",
      points_earned: "إجمالي المكتسب",
      points_redeemed: "إجمالي المستبدل",
      ref_title: "كود الإحالة الخاص بك",
      ref_copied: "تم نسخ الكود",
      ref_desc: "شارك هذا الكود — تكسب نقاطًا عند سداد طلبات الإحالة.",
      claim_title: "المطالبة بطلب سابق",
      claim_desc: "هل طلبت كضيف من قبل؟ اربط طلباتك السابقة بهذا الحساب برقم الطلب ورقم الهاتف المستخدمين عند الطلب.",
      claim_order_num_ph: "SGF-20260827-001",
      claim_phone_ph: "+62xxxxxxxxxx",
      claim_btn: "المطالبة بالطلب",
      claim_success: "تم ربط الطلب بنجاح",
      claim_err_fill: "يرجى ملء رقم الطلب ورقم الهاتف",
      change_pw_title: "تغيير كلمة المرور",
      pw_current_ph: "كلمة المرور الحالية",
      pw_new_ph: "كلمة مرور جديدة (6 كحد أدنى)",
      pw_confirm_ph: "تأكيد كلمة المرور الجديدة",
      pw_btn: "حفظ كلمة المرور الجديدة",
      pw_success: "تم تحديث كلمة المرور",
      pw_err_incomplete: "يرجى ملء جميع حقول كلمة المرور",
      pw_err_mismatch: "تأكيد كلمة المرور غير متطابق",
      order_history: "سجل الطلبات",
      no_orders: "لا توجد طلبات بعد.",
      points_history: "سجل النقاط",
      loading: "جارٍ التحميل...",
      login_success: "تم تسجيل الدخول بنجاح",
    },
    track: {
      title: "تتبع الطلب",
      desc: "أدخل رقم الطلب ورقم الهاتف المستخدم عند الطلب. لا يلزم وجود حساب.",
      order_num: "رقم الطلب",
      phone: "رقم الهاتف (+رمز الدولة)",
      phone_ph: "+62xxxxxxxxxx",
      phone_help: "استخدم التنسيق الدولي مع رمز الدولة، على سبيل المثال +20 أو +62 أو +60.",
      btn_track: "تتبع",
      searching: "جارٍ البحث...",
      err_fill: "يرجى ملء رقم الطلب ورقم الهاتف",
      for_customer: "باسم",
    },
  },
};

export function translate(lang, key) {
  const parts = key.split(".");
  let cur = dict[lang] || dict.id;
  for (const p of parts) {
    cur = cur?.[p];
    if (cur == null) break;
  }
  if (cur == null) {
    cur = dict.id;
    for (const p of parts) cur = cur?.[p];
  }
  return cur == null ? key : cur;
}
